export default class ListNameAuthorsOverflow {
    constructor() {
        this.listNameAuthors = Array.from(document.querySelectorAll('.list-name-authors-overflow'))

        this.handleOverflow()
    }

    update() {
        this.listNameAuthors = Array.from(document.querySelectorAll('.list-name-authors-overflow'))
        this.handleOverflow()
    }

    handleOverflow() {
        this.listNameAuthors.forEach((el) => {
            if (el.querySelector('.hidden-authors')) {
                return
            }

            const authors = el.querySelectorAll('a')

            if (authors.length === 0) {
                return
            }

            authors[0].style.display = 'inline'

            if (authors.length > 1) {
                const hiddenAuthors = authors.length - 1
                const hiddenAuthorsText = document.createElement('span')
                hiddenAuthorsText.classList.add('hidden-authors')
                hiddenAuthorsText.innerText = ` (+${hiddenAuthors})`
                el.appendChild(hiddenAuthorsText)
            }
        });
    }


}
